import SizesMixin from '@/mixins/Sizes.js'

export default
{
    name: 'app-visual-list-widget',

    mixins:
    [
        SizesMixin
    ],

    props:
    {
        reversed: { type: Boolean, default: false }
    },

    mounted()
    {
        this.$list = this.$refs.list
        this.$listInner = this.$refs.listInner

        this.listHeight = 0
        this.listInnerHeight = 0

        // Listen to transition end and reset
        this.$listInner.addEventListener('transitionend', () =>
        {
            if(event.target !== this.$listInner)
            {
                return
            }

            this.reset()
        })

        this.onResize()
    },

    methods:
    {
        onResize()
        {
            // Update heights
            const listHeight = this.$list.offsetHeight
            const listInnerHeight = this.$listInner.offsetHeight

            if(listHeight !== this.listHeight || listInnerHeight !== this.listInnerHeight)
            {
                this.listHeight = listHeight
                this.listInnerHeight = listInnerHeight

                // Reset
                this.reset()
            }
        },

        reset()
        {
            // Content is small than container
            if(this.listInnerHeight < this.listHeight)
            {
                this.$listInner.style.top = '0'
            }

            // Content is bigger than container
            else
            {
                // Reset class and style
                this.$listInner.classList.remove('animated')
                this.$listInner.style.top = '100%'
                this.$listInner.style.transform = 'translateY(0px)'
                this.$listInner.style.transitionDuration = '0s'

                // Animate
                window.requestAnimationFrame(() =>
                {
                    window.requestAnimationFrame(() =>
                    {
                        this.$listInner.classList.add('animated')

                        const translateY = - (this.listInnerHeight + this.listHeight)
                        this.$listInner.style.transform = `translateY(${translateY}px)`

                        const duration = Math.abs(translateY / 100 * 2)
                        this.$listInner.style.transitionDuration = `${duration}s`
                    })
                })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-visual-list-widget/script.js